import {React} from "react";
import {Container} from 'react-bootstrap';

const DatosExperiencia = ({experiencia}) => {
    return(
        <div className="pt-2 pb-5">
            <h1 className="text-center mb-5">{experiencia.elnombre}</h1>
            <Container>
                <div className="noticia-individual-descripcio-llarga">
                    <div dangerouslySetInnerHTML={{__html: experiencia.eltexto}}></div>
                </div>
            </Container>
        </div>
    );
}

export default DatosExperiencia;
